import React from "react";
import { TrueScan } from "../../components/organisms/truescan/TrueScan";
import { usePrimaryOrganization } from "../../hooks";

const TrueScanSunsetNotice = () => (
  <div className="tw-boundary">
    <div className="flex flex-col items-center text-center py-16">
      <img
        src="/assets/images/stay_compliant/privacy_center/truescan-sunset.svg"
        alt="Illustration of a sunset over the horizon"
        className="w-full max-w-xs"
      />
      <h3 className="text-lg font-medium leading-6 text-neutral-800 mt-8 mb-3">
        We're sunsetting TrueScan
      </h3>
      <p className="text-sm font-normal leading-5 text-gray-500 max-w-xl">
        TrueScan is no longer enabled by default, but it's still available on demand. If you'd like
        to keep using TrueScan, please reach out to your customer success contact and we'll enable
        it for your organization.
      </p>
    </div>
  </div>
);

export const TrueScanTab = () => {
  const [organization] = usePrimaryOrganization();

  if (organization && organization.featureTrueScan !== true) {
    return <TrueScanSunsetNotice />;
  }

  return (
    <div className="">
      <TrueScan />
    </div>
  );
};
